import   axios                        from 'axios';
import { API_URLS                  }  from '../urls';
import { BackendResponse             ,
         handleError                 ,
         extractServerConflictMessage }  from '../../dataTypes/backendServicesManagment/types';
import { AudioSlideshow            ,
         initializedAudioSlideshow }  from '../../dataTypes/mediaManagment/audioSlideshow_types';

import { getUserAgentInformations  }  from '../../utils/utils_userAgent';
import { getAppInformations        }  from '../../utils/utils_app';


export interface BackendResponse_AudioSlideshowList extends BackendResponse<AudioSlideshow[]> {}

export const getAudioSlideshowList = async (reload: boolean = false, adminId?: number): Promise<BackendResponse_AudioSlideshowList> => {

  const url = API_URLS.getAudioSlideshowList;

  try
   {
    const response = await axios.get(url, { params: adminId ? { adminId } : {} });

    if (response.status === 200)
          {
           const audioSlideshows: AudioSlideshow[] = response.data.map((audioSlideshow: any) => {

             const defaultAudioSlideshow = initializedAudioSlideshow();

             const categoriesIds = audioSlideshow.mediaCategories?.map((category: any) => category.id) || [];
             const keywordsIds   = audioSlideshow.keywordsLinks?.flatMap((keywordLink: any) => keywordLink.keywordLink?.keywords?.map((keyword: any) => keyword.keyword.id)) || [];

             return {
               ...defaultAudioSlideshow,
               id                                 : audioSlideshow.id                                 ?? defaultAudioSlideshow.id,
               uuid                               : audioSlideshow.uuid                               ?? defaultAudioSlideshow.uuid,
               publicRef                          : audioSlideshow.publicRef                               ?? defaultAudioSlideshow.publicRef,
               creationDate                       : audioSlideshow.creationDate                       ? new Date (audioSlideshow.creationDate.date) : defaultAudioSlideshow.creationDate,
               creationIpAddress                  : audioSlideshow.creationIpAddress                  ?? defaultAudioSlideshow.creationIpAddress,
               mediaType                          : audioSlideshow.mediaType,
               name                               : audioSlideshow.name,
               thumbnail                          : audioSlideshow.thumbnail,
               comment                            : audioSlideshow.comment,
               state                              : audioSlideshow.state,
               active                             : audioSlideshow.active                             ?? defaultAudioSlideshow.active,
               activeScheduled                    : audioSlideshow.activeScheduled                    ?? defaultAudioSlideshow.activeScheduled,
               activeStartDate                    : audioSlideshow.activeStartDate                    ? new Date (audioSlideshow.activeStartDate.date) : defaultAudioSlideshow.activeStartDate,
               activeEndDate                      : audioSlideshow.activeEndDate                      ? new Date (audioSlideshow.activeEndDate.date) : defaultAudioSlideshow.activeEndDate,
               transcoded                         : audioSlideshow.transcoded                         ?? defaultAudioSlideshow.transcoded,
               publicPortal                       : audioSlideshow.publicPortal                       ?? defaultAudioSlideshow.publicPortal,
               requiredUserStatusId               : audioSlideshow.requiredUserStatusId               ?? defaultAudioSlideshow.requiredUserStatusId,
               categoriesIds                      : categoriesIds,
               keywordsIds                        : keywordsIds,
               associatedProductId                : audioSlideshow.associatedProductId                ?? defaultAudioSlideshow.associatedProductId,
               hasSalesCampaign                   : audioSlideshow.hasSalesCampaign                   ?? defaultAudioSlideshow.hasSalesCampaign,

               visible                            : audioSlideshow.visible                            ?? defaultAudioSlideshow.visible,
               title                              : audioSlideshow.title                              ?? defaultAudioSlideshow.title,
               description                        : audioSlideshow.description                        ?? defaultAudioSlideshow.description,
               imageDisplayDuration               : audioSlideshow.imageDisplayDuration               ?? defaultAudioSlideshow.imageDisplayDuration,
               soundPlayingDuration               : audioSlideshow.soundPlayingDuration               ?? defaultAudioSlideshow.soundPlayingDuration,
               soundPlayingLoopMode               : audioSlideshow.soundPlayingLoopMode               ?? defaultAudioSlideshow.soundPlayingLoopMode,
               soundStartTimecodeInAudioSlideShow : audioSlideshow.soundStartTimecodeInAudioSlideshow ?? defaultAudioSlideshow.soundStartTimecodeInAudioSlideshow,
               soundStartTimecodeInSoundFile      : audioSlideshow.soundStartTimecodeInSoundFile      ?? defaultAudioSlideshow.soundStartTimecodeInSoundFile,
               image_id                           : audioSlideshow.imageId                            ?? defaultAudioSlideshow.image_id,
               sound_id                           : audioSlideshow.soundId                            ?? defaultAudioSlideshow.sound_id,
               videoFile                          : audioSlideshow.videoFile                          ?? defaultAudioSlideshow.videoFile,

               storageBytes                       : audioSlideshow.storageBytes                       ?? defaultAudioSlideshow.storageBytes,
               storageComputedAt                  : audioSlideshow.storageComputedAt                  ? new Date (audioSlideshow.storageComputedAt.date) : defaultAudioSlideshow.storageComputedAt,
             };
           });

           return {
                    code    : 1,
                    comment : 'The retrieval of audio slideshows is complete.',
                    payload : audioSlideshows,
                  };
          }
     else {
           return handleError<AudioSlideshow[]>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<AudioSlideshow[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<AudioSlideshow[]>(-102, 'Unknown error');
  }
};

export interface BackendResponse_AudioSlideshow extends BackendResponse <AudioSlideshow>{}

export const getAudioSlideshowById = async (audioSlideshowId: number): Promise<BackendResponse_AudioSlideshow> => {

  return handleError<AudioSlideshow>(-102, 'Unknown error');
}

// Fonction pour mettre à jour la visibilité d'un audio slideshow
export const updateAudioSlideshowVisibility = async (id: number, state: number): Promise<BackendResponse> => {
  const baseUrl = `${API_URLS.patchAudioSlideshowVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);
  const visibilityStr = state === 1 ? 'true' : 'false';

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
	'User-Agent-Informations': `${userAgentInformations}`,
	               'App-Informations': `${appInformations}`,
  };

  try {
    const response = await axios.patch(url, { visibilityStr }, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code: 1,
        comment: 'Audio slideshow visibility updated successfully.',
        payload: {} as any
      };
    } else {
      return handleError<void>(response.status, 'Non-200/204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};

export const updateAudioSlideshow = async ( id                     : number                              ,
                                            active                 : boolean                             ,
                                            title                  : string                              ,
                                            description            : string                              ,
                                            imageDisplayDuration   : string                              ,
                                            soundPlayingLoopMode   : boolean                             ,
                                            imageFileToUpload      : File | null                         ,
                                            imageId                : number                              ,
                                            soundFileToUpload      : File | null                         ,
                                            soundMarkedForDeleting : boolean                             ,
											soundId                : number                              , 
                                            setProgress?           : ((progress: number) => void) | null ,
											adminId?               : number                              ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.patchAudioSlideshow}`;
  const url = baseUrl  // .replace('{id}', `${id}`);  => on ne fait pas un vrai patch à cause de l'upload de media
 
  console.log ( 'updateAudioSlideshow : ' )
  console.log ( '  - active                 = ',active                 )
  console.log ( '  - title                  = ',title                  )
  console.log ( '  - description            = ',description            )
  console.log ( '  - imageDisplayDuration   = ',imageDisplayDuration   )
  console.log ( '  - soundPlayingLoopMode   = ',soundPlayingLoopMode   )
  console.log ( '  - imageFileToUpload      = ',imageFileToUpload      )
  console.log ( '  - imageId                = ',imageId                )
  console.log ( '  - soundFileToUpload      = ',soundFileToUpload      )
  console.log ( '  - soundId                = ',soundId                )
  console.log ( '  - soundMarkedForDeleting = ',soundMarkedForDeleting )

  const formData = new FormData();
                                    formData.append ('id'                     , `${id}`);
                                    formData.append ('active'                 , active.toString());
                                    formData.append ('title'                  , title);
                                    formData.append ('description'            , description);
                                    formData.append ('imageDisplayDuration'   , imageDisplayDuration);
                                    formData.append ('soundPlayingLoopMode'   , soundPlayingLoopMode.toString());
  if (imageFileToUpload !== null) { formData.append ('imageFileToUpload'      , imageFileToUpload); }
                                    formData.append ('imageId'                , imageId.toString());
  if (soundFileToUpload !== null) { formData.append ('soundFileToUpload'      , soundFileToUpload); }
                                    formData.append ('soundId'                , soundId.toString());
                                    formData.append ('soundMarkedForDeleting' , soundMarkedForDeleting.toString());
  if (adminId)                      formData.append ('adminId'                , adminId.toString()               );

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();
  
  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
  };

  try 
   {
    const response = await axios.post ( 
	                                    url , 
										formData, 
										{
                                         headers  ,
                                         onUploadProgress: (event) => {

		                                    if (event.total)
										     {
                                              const percentCompleted = Math.round((event.loaded * 100) / event.total);

                                              if ( setProgress && typeof (setProgress) !== "undefined" )
											   {
                                                setProgress(percentCompleted);
											   }
                                             }
                                          }
                                        }
									  );

    if (response.status === 200 || response.status === 201) 
	      {
           return {
                    code    : 1,
                    comment : 'Audio slideshow updated successfully.',
                    payload : {} as any
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Non-200/201 response from API');
          }
   }
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
  }
};

// Fonction pour créer un nouvel audio slideshow
export const createAudioSlideshow = async ( active               : boolean                             ,
                                            title                : string                              ,
                                            description          : string                              ,
                                            imageDisplayDuration : string                              ,
                                            soundPlayingLoopMode : boolean                             ,
                                            imageFileToUpload    : File | null                         ,
                                            imageId              : number                              ,
                                            soundFileToUpload    : File | null                         ,
											soundId              : number                              , 
                                            setProgress?         : ((progress: number) => void) | null ,
											adminId?             : number                              ): Promise<BackendResponse> => {

  const url = `${API_URLS.createAudioSlideshow}`;

  const formData = new FormData();
                                    formData.append ('title'                , title);
                                    formData.append ('active'               , active.toString());
                                    formData.append ('description'          , description);
                                    formData.append ('imageDisplayDuration' , imageDisplayDuration);
                                    formData.append ('soundPlayingLoopMode' , soundPlayingLoopMode.toString());
  if (imageFileToUpload !== null) { formData.append ('imageFileToUpload'    , imageFileToUpload); }
                                    formData.append ('imageId'              , imageId.toString());
  if (soundFileToUpload !== null) { formData.append ('soundFileToUpload'    , soundFileToUpload); }
                                    formData.append ('soundId'              , soundId.toString());
  if (adminId)                      formData.append ('adminId'              , adminId.toString() );

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();
  
  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
  };

  try 
   {

    const response = await axios.post(url, formData, {
                                           headers  ,
                                           onUploadProgress: (event) => {

		                                        if (event.total)
												 {
                                                  const percentCompleted = Math.round((event.loaded * 100) / event.total);

                                                  if ( setProgress && typeof (setProgress) !== "undefined" )
												   {
                                                    setProgress(percentCompleted);
												   }
                                                 }
                                              }
                                         });


    if (response.status === 201) 
	      {
           return {
                    code    : 1,
                    comment : 'Audio slideshow created successfully.',
                    payload : { id: response.data.id }
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Error creating the audio slideshow');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

// Fonction pour supprimer un audio slideshow
export const deleteAudioSlideshow = async ( id       : number ,
                                            adminId? : number ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.deleteAudioSlideshow}`;
  const url = baseUrl.replace('{id}', `${id}`);

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();
  
  const headers = {
    'Accept': 'application/ld+json',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
    'X-Admin-Id': adminId ?? '' 				   
  };
  
  try
   {
    const response = await axios.delete ( url , { headers });

    if (response.status === 204)
          {
           return {
                    code    : 1,
                    comment : 'The audio slideshow has been successfully deleted.',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error deleting the audio slideshow');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      if (error.response?.status === 409) {
        return {
          code    : -103,
          // Le corps du 409 est une phrase déjà rédigée pour l'utilisateur, qui nomme la
          // chaîne et l'horaire quand le média est au programme. C'est elle qui doit être
          // affichée : le message générique ne dit pas où se trouve l'obstacle.
          comment : extractServerConflictMessage(error.response?.data),
          payload : {} as any
        };
      }
      if (error.response?.status === 404) {
        return {
          code    : -104,
          comment : 'The audio slideshow no longer exists.',
          payload : {} as any
        };
      }
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

export const retryAudioSlideshowTranscoding = async ( id       : number ,
                                                       adminId? : number ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.retryAudioSlideshowTranscoding}`;
  const url = baseUrl.replace('{id}', `${id}`);

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept': 'application/ld+json',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
    'X-Admin-Id': adminId ?? ''
  };

  try
   {
    const response = await axios.post ( url , {} , { headers });

    if (response.status === 204)
          {
           return {
                    code    : 1,
                    comment : 'Le transcodage a été relancé.',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error retrying the audio slideshow transcoding');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

export const cancelAudioSlideshowTranscoding = async ( id       : number ,
                                                        adminId? : number ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.cancelAudioSlideshowTranscoding}`;
  const url = baseUrl.replace('{id}', `${id}`);

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept': 'application/ld+json',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
    'X-Admin-Id': adminId ?? ''
  };

  try
   {
    const response = await axios.post ( url , {} , { headers });

    if (response.status === 204)
          {
           return {
                    code    : 1,
                    comment : 'Le transcodage en échec a été annulé.',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error cancelling the audio slideshow transcoding');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

/*

// src/backendServices/mediaManagment/api_audioSlideshow.ts

import axios from 'axios';
import { API_URLS } from '../urls';
import { BackendResponse, handleError } from '../../dataTypes/backendServicesManagment/types';
import { AudioSlideshow, initializedAudioSlideshow } from '../../dataTypes/mediaManagment/audioSlideshow_types';
import { DocumentWithState } from '../../dataTypes/documentManagment/types';
import { convertDateToString, convertStringToDate, timeStringToSeconds } from '../../dataTypes/timeManagment/utils';
import { createUpload } from '../fileManagment/uploadWithStore';

// ===== FONCTIONS UTILITAIRES POUR LES UPLOADS EN ARRIÈRE-PLAN =====

// Lance l'upload de l'image en arrière-plan
 
const uploadImageInBackground = (audioSlideshowId: number, imageFile: File): void => {
  const uploadConfig = {
    uploadChunkUrl: API_URLS.uploadImageChunk,
    finalizeUploadUrl: API_URLS.finalizeImageUpload,
    chunkSize: 5 * 1024 * 1024, // 5MB pour les images
    maxRetries: 3,
    enableResume: true,
    entityId: audioSlideshowId,
    entityType: 'audioSlideshow_image',
    autoStart: true,
    metadata: {
      audioSlideshowId: audioSlideshowId,
      mediaType: 'image',
      fileType: 'audioSlideshow_image'
    }
  };

  const uploader = createUpload(imageFile, uploadConfig);
  console.log(`Upload image démarré en arrière-plan pour AudioSlideshow ID: ${audioSlideshowId}, Upload ID: ${uploader.id}`);
};

// Lance l'upload du son en arrière-plan

const uploadSoundInBackground = (audioSlideshowId: number, soundFile: File): void => {
  const uploadConfig = {
    uploadChunkUrl: API_URLS.uploadSoundChunk,
    finalizeUploadUrl: API_URLS.finalizeSoundUpload,
    chunkSize: 5 * 1024 * 1024, // 5MB pour les sons
    maxRetries: 3,
    enableResume: true,
    entityId: audioSlideshowId,
    entityType: 'audioSlideshow_sound',
    autoStart: true,
    metadata: {
      audioSlideshowId: audioSlideshowId,
      mediaType: 'sound',
      fileType: 'audioSlideshow_sound'
    }
  };

  const uploader = createUpload(soundFile, uploadConfig);
  console.log(`Upload son démarré en arrière-plan pour AudioSlideshow ID: ${audioSlideshowId}, Upload ID: ${uploader.id}`);
};

// Lance l'upload des documents en arrière-plan
 
const uploadDocumentsInBackground = (audioSlideshowId: number, documents: DocumentWithState[]): void => {
  documents.forEach((doc, index) => {
    // Upload uniquement les nouveaux documents qui ont un fichier
    if (doc.isNew && doc.fileToUpload) {
      const uploadConfig = {
        uploadChunkUrl: API_URLS.uploadDocumentChunk,
        finalizeUploadUrl: API_URLS.finalizeDocumentUpload,
        chunkSize: 5 * 1024 * 1024, // 5MB pour les documents
        maxRetries: 3,
        enableResume: true,
        entityId: audioSlideshowId,
        entityType: 'document',
        autoStart: true,
        metadata: {
          audioSlideshowId: audioSlideshowId,
          documentName: doc.name,
          documentIndex: index,
          mediaType: 'document'
        }
      };

      const uploader = createUpload(doc.fileToUpload, uploadConfig);
      console.log(`Upload document "${doc.name}" démarré en arrière-plan pour AudioSlideshow ID: ${audioSlideshowId}, Upload ID: ${uploader.id}`);
    }
  });
};

// Supprime les documents marqués pour suppression

const deleteMarkedDocuments = async (audioSlideshowId: number, documents: DocumentWithState[]): Promise<void> => {
  const documentsToDelete = documents.filter(doc => doc.isMarkedForDeletion && doc.id);

  for (const doc of documentsToDelete) {
    try {
      const url = API_URLS.deleteDocument.replace('{id}', doc.id!.toString());
      await axios.delete(url, {
        headers: { 'Accept': 'application/ld+json' }
      });
      console.log(`Document ID ${doc.id} supprimé pour AudioSlideshow ID: ${audioSlideshowId}`);
    } catch (error) {
      console.error(`Erreur lors de la suppression du document ID ${doc.id}:`, error);
    }
  }
};

// ===== FONCTIONS API AUDIO SLIDESHOW =====

export interface BackendResponse_AudioSlideshowList extends BackendResponse<AudioSlideshow[]> {}

export const getAudioSlideshowList = async (reload: boolean = false, adminId?: number): Promise<BackendResponse_AudioSlideshowList> => {
  const url = API_URLS.getAudioSlideshowList;

  try {
    const response = await axios.get(url, { params: adminId ? { adminId } : {} });

    if (response.status === 200) {
      const audioSlideshows: AudioSlideshow[] = response.data.map((audioSlideshow: any) => {
        const defaultAudioSlideshow = initializedAudioSlideshow();
        const categoriesIds = audioSlideshow.mediaCategories?.map((category: any) => category.id) || [];
        const keywordsIds = audioSlideshow.keywordsLinks?.flatMap((keywordLink: any) => keywordLink.keywordLink?.keywords?.map((keyword: any) => keyword.keyword.id)) || [];

        return {
          ...defaultAudioSlideshow,
          id: audioSlideshow.id ?? defaultAudioSlideshow.id,
          uuid: audioSlideshow.uuid ?? defaultAudioSlideshow.uuid,
          publicRef: audioSlideshow.publicRef ?? defaultAudioSlideshow.publicRef,
          creationDate: audioSlideshow.creationDate ? new Date(audioSlideshow.creationDate.date) : defaultAudioSlideshow.creationDate,
          creationIpAddress: audioSlideshow.creationIpAddress ?? defaultAudioSlideshow.creationIpAddress,
          mediaType: audioSlideshow.mediaType,
          name: audioSlideshow.name,
          thumbnail: audioSlideshow.thumbnail,
          comment: audioSlideshow.comment,
          state: audioSlideshow.state,
          active: audioSlideshow.active ?? defaultAudioSlideshow.active,
          activeDate: audioSlideshow.activeDate ? new Date(audioSlideshow.activeDate.date) : defaultAudioSlideshow.activeDate,
          transcoded: audioSlideshow.transcoded ?? defaultAudioSlideshow.transcoded,
          publicPortal: audioSlideshow.publicPortal ?? defaultAudioSlideshow.publicPortal,
          requiredUserStatusId: audioSlideshow.requiredUserStatusId ?? defaultAudioSlideshow.requiredUserStatusId,
          categoriesIds: categoriesIds,
          keywordsIds: keywordsIds,
          associatedProductId: audioSlideshow.associatedProductId ?? defaultAudioSlideshow.associatedProductId,
          visible: audioSlideshow.visible ?? defaultAudioSlideshow.visible,
          title: audioSlideshow.title ?? defaultAudioSlideshow.title,
          description: audioSlideshow.description ?? defaultAudioSlideshow.description,
          imageDisplayDuration: audioSlideshow.imageDisplayDuration ?? defaultAudioSlideshow.imageDisplayDuration,
          soundPlayingDuration: audioSlideshow.soundPlayingDuration ?? defaultAudioSlideshow.soundPlayingDuration,
          soundPlayingLoopMode: audioSlideshow.soundPlayingLoopMode ?? defaultAudioSlideshow.soundPlayingLoopMode,
          soundStartTimecodeInAudioSlideshow: audioSlideshow.soundStartTimecodeInAudioSlideshow ?? defaultAudioSlideshow.soundStartTimecodeInAudioSlideshow,
          soundStartTimecodeInSoundFile: audioSlideshow.soundStartTimecodeInSoundFile ?? defaultAudioSlideshow.soundStartTimecodeInSoundFile,
          image_id: audioSlideshow.imageId ?? defaultAudioSlideshow.image_id,
          sound_id: audioSlideshow.soundId ?? defaultAudioSlideshow.sound_id,
          videoFile: audioSlideshow.videoFile ?? defaultAudioSlideshow.videoFile,
        };
      });

      return {
        code: 1,
        comment: 'The retrieval of audio slideshows is complete.',
        payload: audioSlideshows,
      };
    } else {
      return handleError<AudioSlideshow[]>(response.status, 'Non-200 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<AudioSlideshow[]>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<AudioSlideshow[]>(-102, 'Unknown error');
  }
};

export interface BackendResponse_AudioSlideshow extends BackendResponse<AudioSlideshow> {}

export const getAudioSlideshowById = async (audioSlideshowId: number): Promise<BackendResponse_AudioSlideshow> => {
  return handleError<AudioSlideshow>(-102, 'Unknown error');
};

export const updateAudioSlideshowVisibility = async (id: number, state: number): Promise<BackendResponse> => {
  const baseUrl = `${API_URLS.patchAudioSlideshowVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);
  const visibilityStr = state === 1 ? 'true' : 'false';

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
    const response = await axios.patch(url, { visibilityStr }, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code: 1,
        comment: 'Audio slideshow visibility updated successfully.',
        payload: {} as any
      };
    } else {
      return handleError<void>(response.status, 'Non-200/204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Network error');
  }
};

// Créer seulement les métadonnées (non-bloquant)
export const createAudioSlideshowMetadata = async ( active               : boolean ,
                                                    title                : string  ,
                                                    description          : string  ,
                                                    imageDisplayDuration : string  ,
                                                    soundPlayingLoopMode : boolean ,
                                                    publicPortal         : boolean ): Promise<BackendResponse> => {
  const url = `${API_URLS.createAudioSlideshow}`;

  const formData = new FormData();
  
        formData.append ( 'title'                , title                           );
        formData.append ( 'active'               , active.toString()               );
        formData.append ( 'description'          , description                     );
        formData.append ( 'imageDisplayDuration' , imageDisplayDuration            );
        formData.append ( 'soundPlayingLoopMode' , soundPlayingLoopMode.toString() );
        formData.append ( 'publicPortal'         , publicPortal.toString()         );

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
  };

  try 
   {
    const response = await axios.post(url, formData, { headers });

    if (response.status === 201) 
	      {
           const audioSlideshowId = response.data.id;
	  
           return {
                    code    : 1,
                    comment : 'Audio slideshow metadata created successfully.',
                    payload : audioSlideshowId
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Error creating audio slideshow metadata');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }
    return handleError<void>(-102, 'Unknown error');
   }
};

export const createAudioSlideshow = async ( active               : boolean                             ,
                                            title                : string                              ,
                                            description          : string                              ,
                                            imageDisplayDuration : string                              ,
                                            soundPlayingLoopMode : boolean                             ,
                                            imageFileToUpload    : File | null                         ,
                                            soundFileToUpload    : File | null                         ,
                                            publicPortal         : boolean                             ,
                                            documents            : DocumentWithState[]                 ,
                                            setProgress?         : ((progress: number) => void) | null ) : Promise<BackendResponse> => {

  try 
   {
    // 1. Créer d'abord les métadonnées de l'audio slideshow
    const metadataResult = await createAudioSlideshowMetadata ( active               ,
                                                                title                ,
                                                                description          ,
                                                                imageDisplayDuration ,
                                                                soundPlayingLoopMode ,
                                                                publicPortal         );

    if (metadataResult.code !== 1) 
	 {
      return metadataResult;
     }

    const audioSlideshowId = metadataResult.payload;

    // 2. Lancer les uploads en arrière-plan
    if (imageFileToUpload) 
	 {
      uploadImageInBackground(audioSlideshowId, imageFileToUpload);
     }

    if (soundFileToUpload) 
	 {
      uploadSoundInBackground(audioSlideshowId, soundFileToUpload);
     }

    // 3. Lancer l'upload des documents en arrière-plan
    if (documents && documents.length > 0) 
	 {
      uploadDocumentsInBackground(audioSlideshowId, documents);
     }

    // 4. Retourner immédiatement le résultat (non-bloquant)
    const hasUploads = imageFileToUpload || soundFileToUpload || documents.some(doc => doc.isNew && doc.fileToUpload);
    
	return {
      code: 1,
      comment: hasUploads
        ? 'Audio slideshow created successfully. Uploads started in background.'
        : 'Audio slideshow created successfully.',
      payload: { id: audioSlideshowId }
    };
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }
    return handleError<void>(-102, 'Unknown error creating audio slideshow');
   }
};

// Mettre à jour les métadonnées d'un audio slideshow (sans fichiers)
export const updateAudioSlideshowMetadata = async (
  id: number,
  active: boolean,
  title: string,
  description: string,
  imageDisplayDuration: string,
  soundPlayingLoopMode: boolean,
  publicPortal: boolean
): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.patchAudioSlideshow}`;
  const url = baseUrl.replace('{id}', `${id}`);

  const formData = new FormData();
  formData.append('id', `${id}`);
  formData.append('active', active.toString());
  formData.append('title', title);
  formData.append('description', description);
  formData.append('imageDisplayDuration', imageDisplayDuration);
  formData.append('soundPlayingLoopMode', soundPlayingLoopMode.toString());
  formData.append('publicPortal', publicPortal.toString());

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
  };

  try {
    const response = await axios.patch(url, formData, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code: 1,
        comment: 'Audio slideshow metadata updated successfully.',
        payload: id
      };
    } else {
      return handleError<void>(response.status, 'Non-200/204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error');
  }
};

// Mettre à jour un audio slideshow avec uploads en arrière-plan
export const updateAudioSlideshow = async (
  id: number,
  active: boolean,
  title: string,
  description: string,
  imageDisplayDuration: string,
  soundPlayingLoopMode: boolean,
  imageFileToUpload: File | null,
  soundFileToUpload: File | null,
  publicPortal: boolean,
  documents: DocumentWithState[],
  setProgress?: ((progress: number) => void) | null
): Promise<BackendResponse> => {

  try {
    // 1. Mettre à jour d'abord les métadonnées de l'audio slideshow
    const metadataResult = await updateAudioSlideshowMetadata(
      id,
      active,
      title,
      description,
      imageDisplayDuration,
      soundPlayingLoopMode,
      publicPortal
    );

    if (metadataResult.code !== 1) {
      return metadataResult;
    }

    // 2. Si des nouveaux fichiers sont fournis, lancer les uploads en arrière-plan
    if (imageFileToUpload) {
      uploadImageInBackground(id, imageFileToUpload);
    }

    if (soundFileToUpload) {
      uploadSoundInBackground(id, soundFileToUpload);
    }

    // 3. Gérer les documents
    if (documents && documents.length > 0) {
      // Supprimer les documents marqués pour suppression
      await deleteMarkedDocuments(id, documents);

      // Lancer l'upload des nouveaux documents en arrière-plan
      uploadDocumentsInBackground(id, documents);
    }

    // 4. Retourner immédiatement le résultat (non-bloquant)
    const hasUploads = imageFileToUpload || soundFileToUpload || documents.some(doc => doc.isNew && doc.fileToUpload);
    return {
      code: 1,
      comment: hasUploads
        ? 'Audio slideshow updated successfully. Uploads started in background.'
        : 'Audio slideshow updated successfully.',
      payload: {} as any
    };

  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error updating audio slideshow');
  }
};

export const deleteAudioSlideshow = async (id: number): Promise<BackendResponse> => {
  const baseUrl = `${API_URLS.deleteAudioSlideshow}`;
  const url = baseUrl.replace('{id}', `${id}`);

  try {
    const response = await axios.delete(url);

    if (response.status === 204) {
      return {
        code: 1,
        comment: 'The audio slideshow has been successfully deleted.',
        payload: {} as any
      };
    } else {
      return handleError<void>(response.status, 'Error deleting the audio slideshow');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error');
  }
};

*/
